var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgCrystalCard = function SvgCrystalCard(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 600 1000",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_card_svg__radial-gradient",
    cx: 496.1053,
    cy: 81.8193,
    r: 266.8467,
    gradientTransform: "translate(1.386 -0.8342) rotate(0.1588)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdd81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a448ac"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_card_svg__radial-gradient-2",
    cx: 484.9639,
    cy: 299.9768,
    r: 82.5637,
    xlinkHref: "#crystal_card_svg__radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_card_svg__radial-gradient-3",
    cx: 622.2052,
    cy: 188.7667,
    r: 212.2142,
    gradientTransform: "translate(1.386 -0.8342) rotate(0.1588)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cd639b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1933,
    stopColor: "#c9629a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3894,
    stopColor: "#bd5f97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5866,
    stopColor: "#a85991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7848,
    stopColor: "#8c5289"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9819,
    stopColor: "#68487f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#64477e"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_card_svg__radial-gradient-4",
    cx: 310.674,
    cy: 341.3932,
    r: 181.2226,
    xlinkHref: "#crystal_card_svg__radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_card_svg__radial-gradient-5",
    cx: 427.1029,
    cy: 225.8904,
    r: 79.3312,
    xlinkHref: "#crystal_card_svg__radial-gradient-3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_card_svg__radial-gradient-6",
    cx: 524.3755,
    cy: 316.1206,
    r: 105.8374,
    gradientTransform: "translate(1.386 -0.8342) rotate(0.1588)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cc639b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1785,
    stopColor: "#c8629a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3594,
    stopColor: "#bc5f97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5416,
    stopColor: "#a75b92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7245,
    stopColor: "#8b548c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9065,
    stopColor: "#674c83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51477e"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_card_svg__radial-gradient-7",
    cx: 391.2576,
    cy: 214.9797,
    r: 59.6566,
    xlinkHref: "#crystal_card_svg__radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_card_svg__radial-gradient-8",
    cx: 426.7213,
    cy: 251.1918,
    r: 42.9757,
    xlinkHref: "#crystal_card_svg__radial-gradient-3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_card_svg__radial-gradient-9",
    cx: 468.4419,
    cy: 217.7535,
    r: 90.8787,
    xlinkHref: "#crystal_card_svg__radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_card_svg__radial-gradient-10",
    cx: 499.9974,
    cy: 220.2203,
    r: 72.5395,
    xlinkHref: "#crystal_card_svg__radial-gradient-3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_card_svg__radial-gradient-11",
    cx: 534.6864,
    cy: 378.076,
    r: 126.9936,
    xlinkHref: "#crystal_card_svg__radial-gradient-3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_card_svg__radial-gradient-12",
    cx: 474.9799,
    cy: 308.0591,
    r: 51.475,
    gradientTransform: "translate(1.386 -0.8342) rotate(0.1588)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdd81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8348ac"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_card_svg__radial-gradient-13",
    cx: 154.0408,
    cy: -13.846,
    r: 369.6187,
    gradientTransform: "translate(1.386 -0.8342) rotate(0.1588)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#64f968"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#6af66f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7fe988"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_card_svg__radial-gradient-14",
    cx: 162.128,
    cy: 166.0849,
    r: 134.2784,
    gradientTransform: "translate(1.386 -0.8342) rotate(0.1588)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcee21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4651,
    stopColor: "#a1e452"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8293,
    stopColor: "#5fde75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46db83"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_card_svg__radial-gradient-15",
    cx: 183.3095,
    cy: 190.7413,
    r: 199.2838,
    gradientTransform: "translate(1.386 -0.8342) rotate(0.1588)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcee21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4677,
    stopColor: "#a0f576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8301,
    stopColor: "#5ef9b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45fbca"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_card_svg__radial-gradient-16",
    cx: 208.5996,
    cy: 117.8853,
    r: 247.1422,
    gradientTransform: "translate(1.386 -0.8342) rotate(0.1588)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffff40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4925,
    stopColor: "#99f76c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8381,
    stopColor: "#57f188"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3eef93"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_card_svg__radial-gradient-17",
    cx: 413.2703,
    cy: 237.544,
    r: 130.3503,
    gradientTransform: "translate(1.386 -0.8342) rotate(0.1588)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b5af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5826,
    stopColor: "#2ad5a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43e899"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_card_svg__radial-gradient-18",
    cx: 149.8415,
    cy: 446.0614,
    r: 94.04,
    gradientTransform: "translate(1.386 -0.8342) rotate(0.1588)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#64f968"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5934,
    stopColor: "#63f094"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#63eaad"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_card_svg__radial-gradient-19",
    cx: 209.0046,
    cy: 483.9418,
    r: 119.0078,
    xlinkHref: "#crystal_card_svg__radial-gradient-17"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_card_svg__radial-gradient-20",
    cx: 332.3929,
    cy: 227.8586,
    r: 85.9037,
    gradientTransform: "translate(1.386 -0.8342) rotate(0.1588)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4dc6bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2151,
    stopColor: "#51c3c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4332,
    stopColor: "#5db8ca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6526,
    stopColor: "#72a7d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8718,
    stopColor: "#8e90ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a27fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_card_svg__radial-gradient-21",
    cx: 430.2166,
    cy: 305.2154,
    r: 235.0068,
    gradientTransform: "translate(1.386 -0.8342) rotate(0.1588)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b5be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5826,
    stopColor: "#2ad5ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43e8b8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_card_svg__radial-gradient-22",
    cx: 343.4671,
    cy: 271.3011,
    r: 98.7684,
    xlinkHref: "#crystal_card_svg__radial-gradient-21"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_card_svg__radial-gradient-23",
    cx: 306.2825,
    cy: 301.7631,
    r: 116.3439,
    gradientTransform: "translate(1.386 -0.8342) rotate(0.1588)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4dc6bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2323,
    stopColor: "#51c3be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4678,
    stopColor: "#5dbbc0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7047,
    stopColor: "#72acc5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9414,
    stopColor: "#8e99ca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9693cc"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_card_svg__radial-gradient-24",
    cx: 546.3233,
    cy: 648.6454,
    r: 320.3798,
    gradientTransform: "translate(1.386 -0.8342) rotate(0.1588)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7149c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1933,
    stopColor: "#724dc3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3894,
    stopColor: "#7659cb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5866,
    stopColor: "#7c6ed7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7848,
    stopColor: "#858ae7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9819,
    stopColor: "#91aefd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#92b2ff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_card_svg__radial-gradient-25",
    cx: 370.8894,
    cy: 494.7464,
    r: 91.672,
    gradientTransform: "translate(1.386 -0.8342) rotate(0.1588)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4dc6bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2204,
    stopColor: "#51c4be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4438,
    stopColor: "#5dbfbf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6687,
    stopColor: "#72b6c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8932,
    stopColor: "#8eaac7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9ea3c9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_card_svg__radial-gradient-26",
    cx: 457.776,
    cy: 305.6614,
    r: 155.1925,
    gradientTransform: "translate(1.386 -0.8342) rotate(0.1588)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#55bdc5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1897,
    stopColor: "#57b9c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382,
    stopColor: "#5dadbf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5756,
    stopColor: "#6798b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7701,
    stopColor: "#757cac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9636,
    stopColor: "#86589e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8a509b"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_card_svg__radial-gradient-27",
    cx: 382.8468,
    cy: 362.801,
    r: 100.141,
    gradientTransform: "translate(1.386 -0.8342) rotate(0.1588)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a498bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.169,
    stopColor: "#a098bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3404,
    stopColor: "#9497bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5129,
    stopColor: "#7f97b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6862,
    stopColor: "#6396b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8584,
    stopColor: "#3f94ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1b93a9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_card_svg__radial-gradient-28",
    cx: 304.635,
    cy: 336.5772,
    r: 158.8952,
    gradientTransform: "translate(1.386 -0.8342) rotate(0.1588)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#78c6bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2356,
    stopColor: "#77c2c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4744,
    stopColor: "#74b6cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7146,
    stopColor: "#6fa1df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9547,
    stopColor: "#6885f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#667fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_card_svg__radial-gradient-29",
    cx: 500.9932,
    cy: 378.3976,
    r: 104.9566,
    xlinkHref: "#crystal_card_svg__radial-gradient-20"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_card_svg__radial-gradient-30",
    cx: 300.455,
    cy: 326.7001,
    r: 127.9214,
    gradientTransform: "translate(1.386 -0.8342) rotate(0.1588)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b5af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3275,
    stopColor: "#32b6b2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7842,
    stopColor: "#73b8b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8cb9b6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_card_svg__radial-gradient-31",
    cx: 177.5269,
    cy: 493.5635,
    r: 76.8379,
    gradientTransform: "translate(1.386 -0.8342) rotate(0.1588)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b5be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4002,
    stopColor: "#45cbbb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8075,
    stopColor: "#86e0b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9fe8b8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_card_svg__radial-gradient-32",
    cx: 76.5317,
    cy: 386.4235,
    r: 133.3806,
    gradientTransform: "translate(1.386 -0.8342) rotate(0.1588)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b5af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3898,
    stopColor: "#42c0a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8041,
    stopColor: "#83cb9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9ccf99"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_card_svg__radial-gradient-33",
    cx: 347.6025,
    cy: 461.4132,
    r: 163.0094,
    gradientTransform: "translate(1.386 -0.8342) rotate(0.1588)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4dc6bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2356,
    stopColor: "#4ec2c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4744,
    stopColor: "#53b6cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7146,
    stopColor: "#5aa1df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9547,
    stopColor: "#6485f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#667fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_card_svg__radial-gradient-34",
    cx: 224.6926,
    cy: 453.3201,
    r: 116.7314,
    xlinkHref: "#crystal_card_svg__radial-gradient-25"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_card_svg__radial-gradient-35",
    cx: 242.1131,
    cy: 365.0306,
    r: 111.8526,
    xlinkHref: "#crystal_card_svg__radial-gradient-32"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_card_svg__radial-gradient-36",
    cx: 238.0148,
    cy: 492.0194,
    r: 125.5787,
    gradientTransform: "translate(1.386 -0.8342) rotate(0.1588)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3da6c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2951,
    stopColor: "#54b3b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5969,
    stopColor: "#6ac0ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#83cfa3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_card_svg__radial-gradient-37",
    cx: 125.0191,
    cy: 271.356,
    r: 93.1954,
    xlinkHref: "#crystal_card_svg__radial-gradient-21"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_card_svg__radial-gradient-38",
    cx: 407.2911,
    cy: 297.9384,
    r: 128.2632,
    gradientTransform: "translate(1.386 -0.8342) rotate(0.1588)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#009cd1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4778,
    stopColor: "#60c5b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8334,
    stopColor: "#a2e0a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bbeb99"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_card_svg__radial-gradient-39",
    cx: 395.1456,
    cy: 382.6769,
    r: 149.0352,
    xlinkHref: "#crystal_card_svg__radial-gradient-38"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_card_svg__radial-gradient-40",
    cx: 114.1501,
    cy: 257.4002,
    r: 176.5179,
    gradientTransform: "translate(1.386 -0.8342) rotate(0.1588)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#64f968"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2607,
    stopColor: "#4df78c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7629,
    stopColor: "#23f4cd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#12f3e6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_card_svg__radial-gradient-41",
    cx: 383.8724,
    cy: 179.3934,
    r: 84.7827,
    xlinkHref: "#crystal_card_svg__radial-gradient-17"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_card_svg__radial-gradient-42",
    cx: 392.4409,
    cy: 405.2594,
    r: 186.5565,
    xlinkHref: "#crystal_card_svg__radial-gradient-32"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_card_svg__radial-gradient-43",
    cx: 182.91,
    cy: 269.0044,
    r: 92.7774,
    xlinkHref: "#crystal_card_svg__radial-gradient-31"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_card_svg__radial-gradient-44",
    cx: 330.4482,
    cy: 443.4501,
    r: 117.1686,
    xlinkHref: "#crystal_card_svg__radial-gradient-32"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_card_svg__radial-gradient-45",
    cx: 338.3859,
    cy: 285.1998,
    r: 59.6554,
    xlinkHref: "#crystal_card_svg__radial-gradient-21"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_card_svg__radial-gradient-46",
    cx: 351.6508,
    cy: 502.4211,
    r: 165.2907,
    gradientTransform: "translate(1.386 -0.8342) rotate(0.1588)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4dc6bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1952,
    stopColor: "#51c6bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3931,
    stopColor: "#5dc6b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5923,
    stopColor: "#72c5b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7924,
    stopColor: "#8ec4ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9915,
    stopColor: "#b2c3a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b4c3a1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_card_svg__radial-gradient-47",
    cx: 498.9867,
    cy: -302.5654,
    r: 266.8467,
    gradientTransform: "translate(601.5609 616.4574) rotate(-179.8412)",
    xlinkHref: "#crystal_card_svg__radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_card_svg__radial-gradient-48",
    cx: 487.8453,
    cy: -84.408,
    r: 82.5637,
    gradientTransform: "translate(601.5609 616.4574) rotate(-179.8412)",
    xlinkHref: "#crystal_card_svg__radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_card_svg__radial-gradient-49",
    cx: 625.0866,
    cy: -195.618,
    r: 212.2142,
    gradientTransform: "translate(601.5609 616.4574) rotate(-179.8412)",
    xlinkHref: "#crystal_card_svg__radial-gradient-3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_card_svg__radial-gradient-50",
    cx: 313.5554,
    cy: -42.9916,
    r: 181.2226,
    gradientTransform: "translate(601.5609 616.4574) rotate(-179.8412)",
    xlinkHref: "#crystal_card_svg__radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_card_svg__radial-gradient-51",
    cx: 429.9843,
    cy: -158.4944,
    r: 79.3312,
    gradientTransform: "translate(601.5609 616.4574) rotate(-179.8412)",
    xlinkHref: "#crystal_card_svg__radial-gradient-3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_card_svg__radial-gradient-52",
    cx: 527.2569,
    cy: -68.2641,
    r: 105.8374,
    gradientTransform: "translate(601.5609 616.4574) rotate(-179.8412)",
    xlinkHref: "#crystal_card_svg__radial-gradient-6"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_card_svg__radial-gradient-53",
    cx: 394.139,
    cy: -169.4051,
    r: 59.6566,
    gradientTransform: "translate(601.5609 616.4574) rotate(-179.8412)",
    xlinkHref: "#crystal_card_svg__radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_card_svg__radial-gradient-54",
    cx: 429.6028,
    cy: -133.193,
    r: 42.9757,
    gradientTransform: "translate(601.5609 616.4574) rotate(-179.8412)",
    xlinkHref: "#crystal_card_svg__radial-gradient-3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_card_svg__radial-gradient-55",
    cx: 471.3233,
    cy: -166.6313,
    r: 90.8787,
    gradientTransform: "translate(601.5609 616.4574) rotate(-179.8412)",
    xlinkHref: "#crystal_card_svg__radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_card_svg__radial-gradient-56",
    cx: 502.8788,
    cy: -164.1645,
    r: 72.5395,
    gradientTransform: "translate(601.5609 616.4574) rotate(-179.8412)",
    xlinkHref: "#crystal_card_svg__radial-gradient-3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_card_svg__radial-gradient-57",
    cx: 537.5678,
    cy: -6.3088,
    r: 126.9936,
    gradientTransform: "translate(601.5609 616.4574) rotate(-179.8412)",
    xlinkHref: "#crystal_card_svg__radial-gradient-3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_card_svg__radial-gradient-58",
    cx: 477.8613,
    cy: -76.3257,
    r: 51.475,
    gradientTransform: "translate(601.5609 616.4574) rotate(-179.8412)",
    xlinkHref: "#crystal_card_svg__radial-gradient-12"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_card_svg__radial-gradient-59",
    cx: 154.7204,
    cy: -398.2371,
    r: 370.8332,
    gradientTransform: "translate(601.5609 616.4574) rotate(-179.8412)",
    xlinkHref: "#crystal_card_svg__radial-gradient-13"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_card_svg__radial-gradient-60",
    cx: 165.0094,
    cy: -218.2999,
    r: 134.2784,
    gradientTransform: "translate(601.5609 616.4574) rotate(-179.8412)",
    xlinkHref: "#crystal_card_svg__radial-gradient-14"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_card_svg__radial-gradient-61",
    cx: 186.1909,
    cy: -193.6435,
    r: 199.2838,
    gradientTransform: "translate(601.5609 616.4574) rotate(-179.8412)",
    xlinkHref: "#crystal_card_svg__radial-gradient-15"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_card_svg__radial-gradient-62",
    cx: 211.481,
    cy: -266.4995,
    r: 247.1421,
    gradientTransform: "translate(601.5609 616.4574) rotate(-179.8412)",
    xlinkHref: "#crystal_card_svg__radial-gradient-16"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_card_svg__radial-gradient-63",
    cx: 416.1319,
    cy: -146.8407,
    r: 130.3393,
    gradientTransform: "translate(601.5609 616.4574) rotate(-179.8412)",
    xlinkHref: "#crystal_card_svg__radial-gradient-17"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_card_svg__radial-gradient-64",
    cx: 152.7229,
    cy: 61.6766,
    r: 94.04,
    gradientTransform: "translate(601.5609 616.4574) rotate(-179.8412)",
    xlinkHref: "#crystal_card_svg__radial-gradient-18"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_card_svg__radial-gradient-65",
    cx: 211.8861,
    cy: 99.5571,
    r: 119.0078,
    gradientTransform: "translate(601.5609 616.4574) rotate(-179.8412)",
    xlinkHref: "#crystal_card_svg__radial-gradient-17"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_card_svg__radial-gradient-66",
    cx: 335.2744,
    cy: -156.5262,
    r: 85.9037,
    gradientTransform: "translate(601.5609 616.4574) rotate(-179.8412)",
    xlinkHref: "#crystal_card_svg__radial-gradient-20"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_card_svg__radial-gradient-67",
    cx: 433.098,
    cy: -79.1694,
    r: 235.0068,
    gradientTransform: "translate(601.5609 616.4574) rotate(-179.8412)",
    xlinkHref: "#crystal_card_svg__radial-gradient-21"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_card_svg__radial-gradient-68",
    cx: 346.3351,
    cy: -113.0837,
    r: 98.7761,
    gradientTransform: "translate(601.5609 616.4574) rotate(-179.8412)",
    xlinkHref: "#crystal_card_svg__radial-gradient-21"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_card_svg__radial-gradient-69",
    cx: 309.1639,
    cy: -82.6217,
    r: 116.3439,
    gradientTransform: "translate(601.5609 616.4574) rotate(-179.8412)",
    xlinkHref: "#crystal_card_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_card_svg__radial-gradient-70",
    cx: 549.2047,
    cy: 264.2607,
    r: 320.3798,
    gradientTransform: "translate(601.5609 616.4574) rotate(-179.8412)",
    xlinkHref: "#crystal_card_svg__radial-gradient-24"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_card_svg__radial-gradient-71",
    cx: 373.7709,
    cy: 110.3616,
    r: 91.672,
    gradientTransform: "translate(601.5609 616.4574) rotate(-179.8412)",
    xlinkHref: "#crystal_card_svg__radial-gradient-25"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_card_svg__radial-gradient-72",
    cx: 460.6575,
    cy: -78.7234,
    r: 155.1925,
    gradientTransform: "translate(601.5609 616.4574) rotate(-179.8412)",
    xlinkHref: "#crystal_card_svg__radial-gradient-26"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_card_svg__radial-gradient-73",
    cx: 385.7282,
    cy: -21.5837,
    r: 100.141,
    gradientTransform: "translate(601.5609 616.4574) rotate(-179.8412)",
    xlinkHref: "#crystal_card_svg__radial-gradient-27"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_card_svg__radial-gradient-74",
    cx: 307.5164,
    cy: -47.8076,
    r: 158.8952,
    gradientTransform: "translate(601.5609 616.4574) rotate(-179.8412)",
    xlinkHref: "#crystal_card_svg__radial-gradient-28"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_card_svg__radial-gradient-75",
    cx: 503.8746,
    cy: -5.9872,
    r: 104.9566,
    gradientTransform: "translate(601.5609 616.4574) rotate(-179.8412)",
    xlinkHref: "#crystal_card_svg__radial-gradient-20"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_card_svg__radial-gradient-76",
    cx: 303.3364,
    cy: -57.6847,
    r: 127.9214,
    gradientTransform: "translate(601.5609 616.4574) rotate(-179.8412)",
    xlinkHref: "#crystal_card_svg__radial-gradient-30"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_card_svg__radial-gradient-77",
    cx: 180.4084,
    cy: 109.1787,
    r: 76.8379,
    gradientTransform: "translate(601.5609 616.4574) rotate(-179.8412)",
    xlinkHref: "#crystal_card_svg__radial-gradient-31"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_card_svg__radial-gradient-78",
    cx: 79.4132,
    cy: 2.0387,
    r: 133.3806,
    gradientTransform: "translate(601.5609 616.4574) rotate(-179.8412)",
    xlinkHref: "#crystal_card_svg__radial-gradient-32"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_card_svg__radial-gradient-79",
    cx: 350.484,
    cy: 77.0284,
    r: 163.0094,
    gradientTransform: "translate(601.5609 616.4574) rotate(-179.8412)",
    xlinkHref: "#crystal_card_svg__radial-gradient-33"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_card_svg__radial-gradient-80",
    cx: 227.574,
    cy: 68.9353,
    r: 116.7314,
    gradientTransform: "translate(601.5609 616.4574) rotate(-179.8412)",
    xlinkHref: "#crystal_card_svg__radial-gradient-25"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_card_svg__radial-gradient-81",
    cx: 244.9946,
    cy: -19.3541,
    r: 111.8526,
    gradientTransform: "translate(601.5609 616.4574) rotate(-179.8412)",
    xlinkHref: "#crystal_card_svg__radial-gradient-32"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_card_svg__radial-gradient-82",
    cx: 240.8962,
    cy: 107.6346,
    r: 125.5787,
    gradientTransform: "translate(601.5609 616.4574) rotate(-179.8412)",
    xlinkHref: "#crystal_card_svg__radial-gradient-36"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_card_svg__radial-gradient-83",
    cx: 127.9005,
    cy: -113.0287,
    r: 93.1954,
    gradientTransform: "translate(601.5609 616.4574) rotate(-179.8412)",
    xlinkHref: "#crystal_card_svg__radial-gradient-21"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_card_svg__radial-gradient-84",
    cx: 410.1725,
    cy: -86.4464,
    r: 128.2632,
    gradientTransform: "translate(601.5609 616.4574) rotate(-179.8412)",
    xlinkHref: "#crystal_card_svg__radial-gradient-38"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_card_svg__radial-gradient-85",
    cx: 398.0271,
    cy: -1.7079,
    r: 149.0352,
    gradientTransform: "translate(601.5609 616.4574) rotate(-179.8412)",
    xlinkHref: "#crystal_card_svg__radial-gradient-38"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_card_svg__radial-gradient-86",
    cx: 117.0316,
    cy: -126.9845,
    r: 176.5179,
    gradientTransform: "translate(601.5609 616.4574) rotate(-179.8412)",
    xlinkHref: "#crystal_card_svg__radial-gradient-40"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_card_svg__radial-gradient-87",
    cx: 386.7538,
    cy: -204.9914,
    r: 84.7827,
    gradientTransform: "translate(601.5609 616.4574) rotate(-179.8412)",
    xlinkHref: "#crystal_card_svg__radial-gradient-17"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_card_svg__radial-gradient-88",
    cx: 395.3223,
    cy: 20.8746,
    r: 186.5565,
    gradientTransform: "translate(601.5609 616.4574) rotate(-179.8412)",
    xlinkHref: "#crystal_card_svg__radial-gradient-32"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_card_svg__radial-gradient-89",
    cx: 185.7914,
    cy: -115.3804,
    r: 92.7774,
    gradientTransform: "translate(601.5609 616.4574) rotate(-179.8412)",
    xlinkHref: "#crystal_card_svg__radial-gradient-31"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_card_svg__radial-gradient-90",
    cx: 333.3296,
    cy: 59.0653,
    r: 117.1686,
    gradientTransform: "translate(601.5609 616.4574) rotate(-179.8412)",
    xlinkHref: "#crystal_card_svg__radial-gradient-32"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_card_svg__radial-gradient-91",
    cx: 341.2673,
    cy: -99.1849,
    r: 59.6554,
    gradientTransform: "translate(601.5609 616.4574) rotate(-179.8412)",
    xlinkHref: "#crystal_card_svg__radial-gradient-21"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_card_svg__radial-gradient-92",
    cx: 354.5323,
    cy: 118.0363,
    r: 165.2907,
    gradientTransform: "translate(601.5609 616.4574) rotate(-179.8412)",
    xlinkHref: "#crystal_card_svg__radial-gradient-46"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "crystal_card_svg__neutral"
  }, /*#__PURE__*/React.createElement("g", {
    id: "crystal_card_svg__upper"
  }, /*#__PURE__*/React.createElement("g", {
    id: "crystal_card_svg__spikes"
  }, /*#__PURE__*/React.createElement("g", {
    id: "crystal_card_svg__shapes"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.346,278.2616q64.44-89.9511,128.8806-179.9022L435.3875,263.3753Z",
    style: {
      fill: "url(#crystal_card_svg__radial-gradient)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.2987,295.4306,408.1741,340.3,393.23,320.2586q20.0319-11.4444,40.0636-22.889l2.0028-.9944Z",
    style: {
      fill: "url(#crystal_card_svg__radial-gradient-2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.3819,265.3725q-1.0443,15.9972-2.0887,31.9943l1,.0028,89.9334-199.01L435.39,262.3753Z",
    style: {
      fill: "url(#crystal_card_svg__radial-gradient-3)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.39,262.3753l-32.8258,53.7953-4.94-42.9939Z",
    style: {
      fill: "url(#crystal_card_svg__radial-gradient-4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.39,262.3753l-2.097,34.9943-38.31,25.8471Z",
    style: {
      fill: "url(#crystal_card_svg__radial-gradient-5)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.2209,323.55l-33.2,9.8706-2.8329,2.0295L444.13,356.4l1.97,11.0055Z",
    style: {
      fill: "url(#crystal_card_svg__radial-gradient-6)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.4651,235.331l-2.0055,1.9945-28.0553,19.9223,5.0415-14.9861Z",
    style: {
      fill: "url(#crystal_card_svg__radial-gradient-7)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.4651,235.331l-26.8636,34.2845-2.4361-13.976Z",
    style: {
      fill: "url(#crystal_card_svg__radial-gradient-8)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.3914,218.465l-65.0927,76.9656-2.0028.9944-20.0027.9446Z",
    style: {
      fill: "url(#crystal_card_svg__radial-gradient-9)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.3914,218.465l-52.0872,75.0016-2.0028.9945-11.0055,1.97-2-.0056Q486.8437,257.4451,520.3914,218.465Z",
    style: {
      fill: "url(#crystal_card_svg__radial-gradient-10)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.3042,293.4666l-35.9907,53.9973-18.6881-13.8286,39.6705-37.21Z",
    style: {
      fill: "url(#crystal_card_svg__radial-gradient-11)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.0207,333.42,444.1269,357.4l-18.9695-11.0527Z",
    style: {
      fill: "url(#crystal_card_svg__radial-gradient-12)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "crystal_card_svg__highlights",
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M519.7723,104.51l-87.0879,158.755L397.36,273.27l33.8587-6.9847-29.97,46.9956,31.9449-45.34,2.5379-3.839Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.4676,234.5722l-53.1689,60.8529-20.1353,2.0921,18.13-.0977L413.1907,334.314c8.1569-6.7184,21.07-18.0033,40.1024-36.889a11.5489,11.5489,0,0,0,1.0028-.9972Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.1933,333.4582l-23.072,25.9361q12.0346-12.4667,24.0692-24.9334,32.1263-10.6129,32.03-10.9112Q498.1245,323.2485,465.1933,333.4582Z",
    style: {
      fill: "#f2f2f2"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "crystal_card_svg__main"
  }, /*#__PURE__*/React.createElement("g", {
    id: "crystal_card_svg__shapes-2",
    "data-name": "shapes"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M260,290l-3-2,3.38-22.11L294.8315,102.985q2.0083-2.9943,4.0166-5.9888l42.9028,35.119-2.0194,6.9944L265,281Z",
    style: {
      fill: "url(#crystal_card_svg__radial-gradient-13)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.66,164.8185l.9972,1.0028,22.7061,106.0633q.4792,7.5014.9584,15.0027l-3-.0083L193.4,258.7045l-.9264-1.1106Q213.5666,211.2063,234.66,164.8185Z",
    style: {
      fill: "url(#crystal_card_svg__radial-gradient-14)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.3216,286.8873,247.305,292.854,128.17,341.524l-4.0028.9889,68.3062-84.919Z",
    style: {
      fill: "url(#crystal_card_svg__radial-gradient-15)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.66,164.8185l24.6617,122.0688L298.8481,96.9962Z",
    style: {
      fill: "url(#crystal_card_svg__radial-gradient-16)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.5628,193.2924l-1.9893,2.8281-72.2214,79.8-12.0305,10.9667,10.219-19.2555,72.21-135.5166Q342.3755,136.0577,343,140l3,52Z",
    style: {
      fill: "url(#crystal_card_svg__radial-gradient-17)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.8509,456.4848,122.89,442.51l43.2521-90.88,1.0166-5.9972-2.9972-1.0083-35.9943-2.1-4-.0111Q119.009,399.4988,113.8509,456.4848Z",
    style: {
      fill: "url(#crystal_card_svg__radial-gradient-18)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.1584,345.6321l3,.0083,52.9222,28.1468.9944,2.0028-3.0083,2.9916-101.2075,74.72-6.0083,2.9834Q140.5047,401.0585,167.1584,345.6321Z",
    style: {
      fill: "url(#crystal_card_svg__radial-gradient-19)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.5624,200.1787,363,201l-19,40-1.5651,5.1176,4,.011,40.0082-2.8891,8.0027-.9778Z",
    style: {
      fill: "url(#crystal_card_svg__radial-gradient-20)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.4349,246.1176l-.975-9.0028q1.5568-20.4957,3.1136-40.9915l.9893-2.8309,1.019-.1635,16.9833,6.0471.9973,1.0027Q353.4987,223.1482,342.4349,246.1176Z",
    style: {
      fill: "url(#crystal_card_svg__radial-gradient-21)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.3242,286.04,315.731,277q12.5-37.5,25-75l4.8318-8.7076q-1.5639,26.4126-3.1279,52.8252l-1.0055,1.9972-25.1,35.93Z",
    style: {
      fill: "url(#crystal_card_svg__radial-gradient-22)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.2213,323.2919q-5.3877-40.5152-10.7755-81.03l-52.0109,3.8559,3.9834,6.011q28.4028,35.0788,56.8057,70.1578Z",
    style: {
      fill: "url(#crystal_card_svg__radial-gradient-23)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.94,355.8859l-.8071-.486-38.0608,21.8946-1.232,1.0015.2264.9957,73.8168,66.2048,2.9945,2.0084Z",
    style: {
      fill: "url(#crystal_card_svg__radial-gradient-24)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.85,456.9255l8.0055-1.9778,120.116-41.6672,1.0083-2.9973,3.0859-30.9915.0056-2-2.0028.9944-124.2074,74.656Z",
    style: {
      fill: "url(#crystal_card_svg__radial-gradient-25)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.8773,447.5049,404.84,378.296l-3.8472,33.7713.9794,1.2159L476.88,446.491Z",
    style: {
      fill: "url(#crystal_card_svg__radial-gradient-26)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.85,456.9255l209.027-9.4206-80.8849-35.4376Z",
    style: {
      fill: "url(#crystal_card_svg__radial-gradient-27)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.1243,358.22l24.9445,20.0692.7708.0071,1.24-4.0015.1358-49-.9944-2.0028-1.0028.9972Z",
    style: {
      fill: "url(#crystal_card_svg__radial-gradient-28)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.94,355.8859l-39.7182-32.594q-.1909,27.502-.3817,55.0041Z",
    style: {
      fill: "url(#crystal_card_svg__radial-gradient-29)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.4349,246.1176l.9806,7.0027q15.3711,46.5428,30.7421,93.0856l5.714,12.002,25.35-34.916Z",
    style: {
      fill: "url(#crystal_card_svg__radial-gradient-30)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.7734,484.4708l5.0055-1.9861,62.1051-37.828,2.0055-1.9945-4-.0111-53.033,11.8531-7.0056,1.9806Z",
    style: {
      fill: "url(#crystal_card_svg__radial-gradient-31)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.075,375.79l-2.0138,4.9944L180.895,440.6705l-3.0055,1.9917-64.0386,13.8226Z",
    style: {
      fill: "url(#crystal_card_svg__radial-gradient-32)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.8716,358.2079,404.84,378.296,272.85,456.9255l6.0194-6.9834L372,362Z",
    style: {
      fill: "url(#crystal_card_svg__radial-gradient-33)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.9974,403.8314l69.947,19.194-36.0941,33.9Z",
    style: {
      fill: "url(#crystal_card_svg__radial-gradient-34)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.85,456.9255l-7-.0194-80.9665-12.2245-6.9944-2.0194L224.075,375.79Q248.4627,416.3577,272.85,456.9255Z",
    style: {
      fill: "url(#crystal_card_svg__radial-gradient-35)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.7734,484.4708,272.85,456.9255,177.89,442.6622Z",
    style: {
      fill: "url(#crystal_card_svg__radial-gradient-36)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.3216,286.8873l-4.0055,1.9889L168.164,343.6349l-1.0056,1.9972L224.0751,375.79,228,370l31-78Z",
    style: {
      fill: "url(#crystal_card_svg__radial-gradient-37)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.4349,246.1176l37.4367,112.09-3.7417-1.9965-57.82-65.1605-3.9861-5.0111Z",
    style: {
      fill: "url(#crystal_card_svg__radial-gradient-38)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.2159,325.1394l-2.0138,4.9945-2.1414,50.9942.9806,7.0028,32.83-29.923Q365.0438,341.6737,350.2159,325.1394Z",
    style: {
      fill: "url(#crystal_card_svg__radial-gradient-39)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.1669,342.5129l135.1547-55.6256-92.1632,58.7448Z",
    style: {
      fill: "url(#crystal_card_svg__radial-gradient-40)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.7509,132.1152q11.4058,34.0317,22.8115,68.0635l-19-6.8863Q343.6569,162.7038,341.7509,132.1152Z",
    style: {
      fill: "url(#crystal_card_svg__radial-gradient-41)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.3242,286.04l-.0083,3q15.3654,48.5427,30.731,97.0855l1.9944,2.0056,3.1746-62.9915Z",
    style: {
      fill: "url(#crystal_card_svg__radial-gradient-42)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.3586,286.047l-1.0427,2.99-83.23,82.77L224.075,375.79q17.6234-44.4513,35.2466-88.9027l2.0028-.9944,51.0026-.8586Z",
    style: {
      fill: "url(#crystal_card_svg__radial-gradient-43)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.075,375.79l90.2836-89.743Q330.7,337.0889,347.0413,388.1309l-10-.0277L231.07,377.8094Z",
    style: {
      fill: "url(#crystal_card_svg__radial-gradient-44)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.5628,193.2924,314.3586,286.047l-55.037.84,24.56-26.6536Z",
    style: {
      fill: "url(#crystal_card_svg__radial-gradient-45)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.075,375.79l122.9663,12.3409-39.1,35.8917-65.95-18.1828Z",
    style: {
      fill: "url(#crystal_card_svg__radial-gradient-46)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "crystal_card_svg__highlights-2",
    "data-name": "highlights",
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M364.5624,200.1787l-16.9806-7.0471c-3.37-41.0192-5.2927-61.0534-5.8309-61.0164s.2992,20.124,2.574,61.1738L277.274,267.376l67.0406-70.3734q-2.458,48.4407-1.6661,48.4957.801.0538,4.925-49.3667Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.6476,288.3683l-36.4723,86.9191,20.7259,32.6157,65.47,16.4193-63.7577-18.9445-19.9356-30.0836Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.3216,286.91l47,.13,33.8973,37.0941q-.48,32.006-.9608,64.012l2.6827-65.0541-35.1753-37.99Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.2157,325.2919l-1.1127,50.8847L381.38,359.532l21.6885,18.7541Q337.96,417.6059,272.85,456.9255l130.21-75.6394-2.0859,30.9944q2.5443-15.993,5.0887-31.9861L472.9,439.48,407.3419,378.303,444.13,356.4l-36.7808,19.4007Q406.2823,350.5463,405.2157,325.2919Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.1262,257.24q-.475-.2195,41.5337-92.4212,51.6066-55.3606,52.1522-54.8556.55.5023-50.11,57.0323,11.31,59.946,22.6195,119.8921L234.2161,170.7019Q193.59,257.4495,193.1262,257.24Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.6351,342.744l38.5289.8853,83.1382-49.77L170.1584,345.64l48.925,27.1357L167.15,348.6321l-40.2216,79.8888,37.2244-80.8971Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.5429,207.1926l25.6618,35.949q5.0084,40.0752,10.0166,80.15-6.38-39.5582-12.76-79.1164l-38.0235.9753,36.7925-3.4545Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.0755,394.6914l-33.4142,45.9675-39.7966,10.89,38.4166-8.6762L151.7171,458.9l27.2744-14.779q58.06,8.2416,58.1593,7.5885.0994-.6481-56.9146-10.0608Z",
    style: {
      fill: "#f2f2f2"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "crystal_card_svg__lower"
  }, /*#__PURE__*/React.createElement("g", {
    id: "crystal_card_svg__spikes_copy",
    "data-name": "spikes copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "crystal_card_svg__shapes_copy",
    "data-name": "shapes copy"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M204.654,721.7384,75.7734,901.6406l87.8391-165.0159Z",
    style: {
      fill: "url(#crystal_card_svg__radial-gradient-47)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.7013,704.5694l47.1246-44.87L205.77,679.7414,165.7068,702.63l-2.0028.9945Z",
    style: {
      fill: "url(#crystal_card_svg__radial-gradient-48)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.6181,734.6275q1.0443-15.9972,2.0887-31.9943l-1-.0028-89.9334,199.01L163.61,737.6247Z",
    style: {
      fill: "url(#crystal_card_svg__radial-gradient-49)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.61,737.6247l32.8258-53.7953,4.9405,42.9939Z",
    style: {
      fill: "url(#crystal_card_svg__radial-gradient-50)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.61,737.6247l2.097-34.9943,38.31-25.8471Z",
    style: {
      fill: "url(#crystal_card_svg__radial-gradient-51)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.7791,676.45l33.2-9.8706,2.8329-2.0295L154.87,643.6l-1.9695-11.0055Z",
    style: {
      fill: "url(#crystal_card_svg__radial-gradient-52)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.5349,764.669l2.0055-1.9945,28.0553-19.9223-5.0415,14.9861Z",
    style: {
      fill: "url(#crystal_card_svg__radial-gradient-53)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.5349,764.669l26.8636-34.2845,2.4361,13.976Z",
    style: {
      fill: "url(#crystal_card_svg__radial-gradient-54)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.6086,781.535l65.0927-76.9656,2.0028-.9944,20.0027-.9446Z",
    style: {
      fill: "url(#crystal_card_svg__radial-gradient-55)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.6086,781.535l52.0872-75.0016,2.0028-.9945,11.0055-1.97,2,.0056Q112.1563,742.5549,78.6086,781.535Z",
    style: {
      fill: "url(#crystal_card_svg__radial-gradient-56)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.6958,706.5334l35.9907-53.9973,18.6881,13.8286-39.67,37.21Z",
    style: {
      fill: "url(#crystal_card_svg__radial-gradient-57)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.9793,666.58l20.8938-23.98,18.97,11.0527Z",
    style: {
      fill: "url(#crystal_card_svg__radial-gradient-58)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "crystal_card_svg__highlights_copy",
    "data-name": "highlights copy",
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.2277,895.4906l87.0879-158.7551L201.64,726.73l-33.8587,6.9847,29.97-46.9956-31.9449,45.34-2.5379,3.8391Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.5324,765.4278q26.5845-30.4265,53.1689-60.8528l20.1353-2.0922-18.13.0977,38.1025-36.8945c-8.1569,6.7184-21.07,18.0033-40.1024,36.889a11.5489,11.5489,0,0,0-1.0028.9972Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.8067,666.5418l23.072-25.9361L132.81,665.5391q-32.1263,10.613-32.03,10.9112Q100.8756,676.7515,133.8067,666.5418Z",
    style: {
      fill: "#f2f2f2"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "crystal_card_svg__main_copy",
    "data-name": "main copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "crystal_card_svg__shapes_copy-2",
    "data-name": "shapes copy"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M343,710l-4.38,24.11L304.1685,897.015q-2.0083,2.9945-4.0166,5.9888l-42.9028-35.119,2.0194-6.9944Q298.6342,786.4451,338,712Z",
    style: {
      fill: "url(#crystal_card_svg__radial-gradient-59)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.34,835.1815l-.9972-1.0028L340.6368,728.1154l-.9584-15.0027,3,.0083,62.9221,28.1745.9264,1.1106Q385.4335,788.7937,364.34,835.1815Z",
    style: {
      fill: "url(#crystal_card_svg__radial-gradient-60)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.6784,713.1127l12.0166-5.9667L470.83,658.476l4.0028-.9889q-34.1531,42.46-68.3062,84.919Z",
    style: {
      fill: "url(#crystal_card_svg__radial-gradient-61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.34,835.1815q-12.3309-61.0344-24.6617-122.0688L300.1519,903.0038Z",
    style: {
      fill: "url(#crystal_card_svg__radial-gradient-62)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.4372,806.7076l1.9893-2.8281,72.2214-79.8,12.0305-10.9667-10.219,19.2555-72.21,135.5166Q256.6245,864.9424,256,862l-3-50Z",
    style: {
      fill: "url(#crystal_card_svg__radial-gradient-63)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.1491,543.5153,476.11,557.49q-21.6261,45.44-43.2521,90.88l-1.0166,5.9972,2.9972,1.0083,35.9943,2.1,4,.0111Q479.991,600.5012,485.1491,543.5153Z",
    style: {
      fill: "url(#crystal_card_svg__radial-gradient-64)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.8416,654.3679l-3-.0083-52.9222-28.1468-.9944-2.0028,3.0083-2.9916,101.2075-74.72,6.0083-2.9833Q458.4953,598.9415,431.8416,654.3679Z",
    style: {
      fill: "url(#crystal_card_svg__radial-gradient-65)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.4376,799.8213,236,798l20-40,.5651-4.1176-4-.011-40.0082,2.8891-8.0027.9778Z",
    style: {
      fill: "url(#crystal_card_svg__radial-gradient-66)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5651,753.8825l.975,9.0027q-1.5568,20.4957-3.1136,40.9915l-.9893,2.8309-1.019.1636-16.9833-6.0471-.9973-1.0028Q245.5013,776.8518,256.5651,753.8825Z",
    style: {
      fill: "url(#crystal_card_svg__radial-gradient-67)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.6758,713.96,285,718l-27,78-4.5628,10.7076q1.5639-26.4126,3.1279-52.8252l1.0055-1.9972,25.1-35.9305Z",
    style: {
      fill: "url(#crystal_card_svg__radial-gradient-68)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.7787,676.7081q5.3877,40.5152,10.7755,81.03l52.0109-3.8558-3.9834-6.0111L195.776,677.7137Z",
    style: {
      fill: "url(#crystal_card_svg__radial-gradient-69)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.0605,644.1141l.8071.486,38.0608-21.8945,1.232-1.0016-.2264-.9957-73.8168-66.2048-2.9945-2.0083Z",
    style: {
      fill: "url(#crystal_card_svg__radial-gradient-70)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.15,543.0745l-8.0055,1.9778L198.0282,586.72l-1.0083,2.9972-3.0859,30.9915-.0056,2,2.0028-.9944,124.2074-74.656Z",
    style: {
      fill: "url(#crystal_card_svg__radial-gradient-71)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.1227,552.4952,194.16,621.704l3.8472-33.7713-.9794-1.2159L122.12,553.509Z",
    style: {
      fill: "url(#crystal_card_svg__radial-gradient-72)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.15,543.0745l-209.027,9.4207,80.8849,35.4375Z",
    style: {
      fill: "url(#crystal_card_svg__radial-gradient-73)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.8757,641.78l-24.9445-20.0692-.7708-.0071-1.24,4.0015-.1358,49,.9944,2.0027,1.0028-.9972Z",
    style: {
      fill: "url(#crystal_card_svg__radial-gradient-74)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.0605,644.1141l39.7182,32.594q.191-27.502.3817-55.0041Z",
    style: {
      fill: "url(#crystal_card_svg__radial-gradient-75)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5651,753.8825l-.9806-7.0028q-15.3711-46.5428-30.7421-93.0856l-5.714-12.002-25.35,34.916Z",
    style: {
      fill: "url(#crystal_card_svg__radial-gradient-76)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.2266,515.5292l-5.0055,1.9862-62.1051,37.828-2.0055,1.9944,4,.0111,53.033-11.8531,7.0056-1.9805Z",
    style: {
      fill: "url(#crystal_card_svg__radial-gradient-77)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.925,624.21l2.0138-4.9944L418.105,559.33l3.0055-1.9917,64.0386-13.8225Z",
    style: {
      fill: "url(#crystal_card_svg__radial-gradient-78)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.1284,641.7921,194.16,621.704,326.15,543.0745l-6.0194,6.9834L228,638Z",
    style: {
      fill: "url(#crystal_card_svg__radial-gradient-79)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.0026,596.1686l-69.947-19.194,36.0941-33.9Z",
    style: {
      fill: "url(#crystal_card_svg__radial-gradient-80)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.15,543.0745l7,.0194,80.9665,12.2245,6.9944,2.0194L374.925,624.21Q350.5372,583.6424,326.15,543.0745Z",
    style: {
      fill: "url(#crystal_card_svg__radial-gradient-81)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.2266,515.5292,326.15,543.0745l94.9608,14.2633Z",
    style: {
      fill: "url(#crystal_card_svg__radial-gradient-82)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.6784,713.1127l4.0055-1.9889,87.1521-54.7587,1.0056-1.9972L374.9249,624.21,368,637l-21,49Q343.3393,699.5564,339.6784,713.1127Z",
    style: {
      fill: "url(#crystal_card_svg__radial-gradient-83)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5651,753.8825l-37.4367-112.09,3.7417,1.9965,57.82,65.1606,3.9861,5.011Q270.6205,733.9213,256.5651,753.8825Z",
    style: {
      fill: "url(#crystal_card_svg__radial-gradient-84)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.7841,674.8606l2.0138-4.9945,2.1414-50.9942-.9806-7.0028-32.83,29.923Q233.9562,658.3263,248.7841,674.8606Z",
    style: {
      fill: "url(#crystal_card_svg__radial-gradient-85)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.8331,657.4871,339.6784,713.1127l92.1632-58.7448Z",
    style: {
      fill: "url(#crystal_card_svg__radial-gradient-86)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.2491,867.8848q-11.4059-34.0317-22.8115-68.0635l19,6.8863Q255.3431,837.2962,257.2491,867.8848Z",
    style: {
      fill: "url(#crystal_card_svg__radial-gradient-87)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.6758,713.96l.0083-3q-15.3654-48.5427-30.731-97.0855l-1.9944-2.0056-3.1746,62.9915Z",
    style: {
      fill: "url(#crystal_card_svg__radial-gradient-88)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.6414,713.953l1.0427-2.99,83.23-82.77,6.0111-3.9834q-17.6234,44.4514-35.2466,88.9027l-2.0028.9944-51.0026.8587Z",
    style: {
      fill: "url(#crystal_card_svg__radial-gradient-89)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.925,624.21l-90.2836,89.743Q268.3,662.9112,251.9587,611.8691l10,.0278,105.9719,10.2937Z",
    style: {
      fill: "url(#crystal_card_svg__radial-gradient-90)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.4372,806.7076l31.2042-92.7546,55.037-.84-24.56,26.6537Z",
    style: {
      fill: "url(#crystal_card_svg__radial-gradient-91)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.925,624.21,251.9587,611.8691l39.1-35.8917,65.95,18.1829Z",
    style: {
      fill: "url(#crystal_card_svg__radial-gradient-92)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "crystal_card_svg__highlights_copy-2",
    "data-name": "highlights copy",
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M234.4376,799.8213l16.9806,7.0471c3.37,41.0192,5.2927,61.0534,5.8309,61.0164s-.2992-20.124-2.574-61.1738l67.0509-74.087-67.0406,70.3734q2.458-48.4407,1.6661-48.4957-.801-.0539-4.925,49.3667Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.3524,711.6317l36.4723-86.919L356.0988,592.097l-65.47-16.4194,63.7577,18.9445,19.9356,30.0836Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.6784,713.0905l-47-.13-33.8973-37.0941q.48-32.0059.9608-64.012l-2.6827,65.0541,35.1753,37.99Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.7843,674.7081l1.1127-50.8847L217.62,640.468l-21.6885-18.7541L326.15,543.0745,195.94,618.7139l2.0859-30.9944q-2.5443,15.9932-5.0887,31.9861L126.1005,560.52l65.5576,61.1769L154.87,643.6l36.7808-19.4007Q192.7177,649.4537,193.7843,674.7081Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.8738,742.76q.475.2194-41.5337,92.4212-51.6066,55.3606-52.1522,54.8557-.55-.5025,50.11-57.0324-11.31-59.946-22.62-119.8921l25.1055,116.1854Q405.41,742.5506,405.8738,742.76Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.3649,657.256l-38.5289-.8853-83.1382,49.77L428.8416,654.36l-48.925-27.1357,51.9333,24.144,40.2216-79.8888-37.2244,80.8971Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.4571,792.8075l-25.6618-35.9491q-5.0084-40.0752-10.0166-80.15,6.38,39.5582,12.76,79.1164l38.0235-.9753L207.77,758.3037Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.9245,605.3086l33.4142-45.9675,39.7966-10.89-38.4166,8.6762,23.5642-16.0272L420.0085,555.88q-58.0605-8.2416-58.1593-7.5885-.0995.6481,56.9146,10.0608Z",
    style: {
      fill: "#f2f2f2"
    }
  }))))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgCrystalCard);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/crystal_card.bdd9e9949cbcbd363a426776759b3802.svg";